import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState: Array<string> = [];

interface CategoriesResponse {
	categories: Array<string>;
}

export const { thunk: fetchCategories, slice: eventCategoriesSlice } = getThunkAndSlice<
	Record<string, never>,
	CategoriesResponse,
	Array<string>
>({
	initialState,
	path: "/api/events/filter/categories",
	onAfterRequest: async (data: CategoriesResponse | Array<string>) => {
		if (Array.isArray(data)) return data;
		return data.categories ?? [];
	},
});

export default eventCategoriesSlice.reducer;
